import { useMemo } from 'react'
import { useFormState } from 'react-hook-form'
import { filter, find, toNumber } from 'lodash-es'
import { Checkbox } from '@ui/forms'
import { DefaultValues } from '../../types'

interface Props {
  guid: string
  position: 'start' | 'end'

  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const AddRipCheckbox = ({ guid, position, onMouseEnter, onMouseLeave }: Props) => {
  const { defaultValues } = useFormState<DefaultValues>()

  const locked = useMemo(() => {
    const rips = (defaultValues?.rips || []) as PositionForVertical[]

    const ripsOnElement = filter(rips, rip => rip.wall_guid === guid)

    return !!find(
      ripsOnElement,
      rip => toNumber(rip.relative_position) === (position === 'start' ? 0 : 1),
    )
  }, [defaultValues, guid, position])

  return (
    <Checkbox
      name={`config.${guid}.${position}`}
      disabled={locked}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{ padding: 0 }}
    />
  )
}

export default AddRipCheckbox
